import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FashionCard } from "./FashionCard";

const CATEGORIES = [
  { imageUrl: "SBD/view1.jpg", label: "Best Seller", link: "/shop/best-seller" },
  { imageUrl: "SBD/view2.jpg", label: "Deluxe Collection", link: "/shop/deluxe-collection" },
  { imageUrl: "SBD/view3.jpg", label: "Recently Added", link: "/shop/recently-added" },
];

export const FashionCategory = () => (
  <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 10 }, py: { xs: 6, md: 10 } }}>
    <Grid container spacing={{ xs: 2, md: 3 }}>
      {CATEGORIES.map((cat) => (
        <Grid key={cat.label} item xs={12} sm={4}>
          <FashionCard {...cat} />
        </Grid>
      ))}
    </Grid>
  </Box>
);
